// extracted by mini-css-extract-plugin
export var container = "_a4-0";
export var icon = "_a4-1";
export var text = "_a4-2";